<template>
    <div class="row">
        <div class="col-sm-12" style="overflow: hidden;">
            <!-- <div class="hidden"><label for="">{{computeMapData}}</label></div> -->
            <div v-if="chartHasNoData" class="chart-has-no-data">
              <img src="static/img/no_data.svg" style="">
              <!-- <b-notification type="is-custom" :active.sync="chartHasNoData">
                <strong>Info! &nbsp;</strong> No data available
              </b-notification> -->
            </div>
            <div v-else class="chart-wrapper">
                <div class="chart-stage">
                    <highmaps :options="options" ref="highmaps"></highmaps>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import map_data from '@/assets/js-on/nigmap_region_data';
    export default {
        name: 'nigregion-map',
        props: ['relativeIndicator','selectedIndicator','appData','sourceClicked','yearClicked','indicatorClicked'],
        components: {},
        data() {
            var data = [
                ['ng-ne', 0],
                ['ng-nw', 1],
                ['ng-nc', 2],
                ['ng-se', 3],
                ['ng-sw', 4],
                ['ng-ss', 5]
            ];
            return {
                chartHasNoData: false,
                series_data: [],
                optionYear: [],
                optionSources: [],
                lsData: JSON.parse(this.$ls.get('car_other_dataset')),
                selectedSource: this.sourceClicked,
                selectedYear: '',
                optionStates: ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa",
                    "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo",
                    "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "National",
                    "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe",
                    "Zamfara", "North-East", "North-West", "North-Central", "South-East", "South-West", "South-South"],
                dataSources: ['MICS', 'NHMIS', 'NNHS', 'NDHS', 'NMIS', 'NARHS', 'IHME', 'World Bank', 'WHO-GHO', 'WUENIC'],
                stateToShortCode: {
                    'North-East': 'ng-ne',
                    'North-West': 'ng-nw',
                    'North-Central': 'ng-nc',
                    'South-East': 'ng-se',
                    'South-West': 'ng-sw',
                    'South-South': 'ng-ss',
                },
                mapPlotData: null,
                options: {
                    chart: {
                        map: 'countries/ng/ng-all',
                        borderColor: '#335cad',
                        height: 438
                    },

                    colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
                        '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],

                    credits: {
                        enabled: true,
                        text: 'Map of Nigeria'
                    },

                    title: {
                        text: 'Loading...',
                        style: {
                        fontSize: '16px',
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: '600'
                        }
                    },

                    subtitle: {
                        text: "Loading...",
                        style: {
                        fontSize: '11px',
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: 'normal'
                        }
                    },

                    exporting: {
                      csv: {
                        dateFormat: '%Y-%m-%d'
                      }
                    },

                    mapNavigation: {
                        enabled: true,
                        buttonOptions: {
                            verticalAlign: 'middle',
                            align: 'right'
                        }
                    },

                    legend: {
                        enabled: true,
                        layout: 'horizontal',
                        align: 'right'
                    },

                    colorAxis: {
                        // min: 0,
                        // max: 100,
                        minColor: '#E6E7E8',
                        maxColor: '#114663'
                    },

                    plotOptions: {
                        map: {
                            allAreas: false,
                            mapData: map_data, // Highcharts.maps['countries/ng/ng-all'],
                            states: {
                                hover: {
                                    color: '#BADA55'
                                }
                            },
                            joinBy: "hc-key",
                            dataLabels: {
                                allowOverlap:true,
                                align:'center',
                                crop:true,
                                style:{
                                  fontFamily: "'Open Sans', sans-serif",
                                  fontSize:10
                                },
                                enabled: true,
                                //format: '{point.name}',
                                color: '#FFFFFF',
                                formatter: function () {
                                    if (this.point.value) {
                                        return this.point.name;
                                    }
                                }
                            },
                            tooltip: {
                                headerFormat: '<b>{series.name}</b><br>',
                                pointFormat: '{point.name}: <b>{point.value:.2f}</b>'
                            }
                        }
                    },
                    series: [{
                        type: "map",
                        data: data,
                        name: 'Random Name',
                    }],
                    exporting: {
                        buttons: {
                            contextButton: {
                                menuItems: [
                                    "printChart",
                                    "separator",
                                    "downloadPNG",
                                    "downloadJPEG",
                                    "downloadPDF",
                                    "downloadSVG",
                                    "separator",
                                    "downloadCSV",
                                    "downloadXLS",
                                    //"viewData",
                                    "openInCloud"
                                ],
                                symbol: 'download',
                                // symbolStrokeWidth: 2,
                                // symbolFill: '#330033',
                                // symbolStroke: '#b3d4fc'
                            }
                        }
                    }
                }
            }
        },
        methods: {
            getCurrentSourceOptions(indicator) {
            let sources = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            for(var k in this.dataSources){
              for(var i in statesByIndicatorByYear){
                for(var j in statesByIndicatorByYear[i]){
                  if(i !== 'National'){
                    let indicatorSource = indicator + ' -> ' + this.dataSources[k];
                    let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource)-1;
                    if(statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex>0){
                      if(sources.indexOf(this.dataSources[k])<0)
                        sources.push(this.dataSources[k]);
                      break;
                    }
                  }
                }
              }
            }
            this.optionSources = sources;
            },
            getYearOptionsWithData(indicator,source){
                let years = [];
                let statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
                let indicatorSource = indicator + ' -> ' + source;
                let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource)-1;
                this.optionStates.map((elem,index) => {
                if(elem !== 'National'){
                    statesByIndicatorByYear[elem].map((el,i) => {
                    if(el[indicatorSourceIndex] !== "" && indicatorSourceIndex>0){
                        if(years.indexOf(el[0]) < 0){
                        years.push(el[0])
                        }
                    }
                    });
                }
                });
                this.optionYear = years;
            },
            sourceAndYearComputation(indicator){
                this.getCurrentSourceOptions(indicator);
                let randomSource = Math.floor(Math.random() * this.optionSources.length);
                this.selectedSource = this.sourceClicked;
                this.getYearOptionsWithData(indicator,this.selectedSource);
                if(this.optionYear.length > 0){
                    this.selectedYear = this.optionYear.reduce(function(a, b) { return Math.max(a, b); });
                } else {
                    this.selectedYear = 0;
                }
            },
            plotMap(data) {
                // Create the chart
                if (this.mapPlotData) {
                    this.options.series[0].data = Object.keys(this.stateToShortCode).map( (elem, index) => {
                        return [this.stateToShortCode[elem], data[elem]] //this.mapPlotData[elem]];
                    });
                }
            },
            computeMapData(indicator,source) {
                var ngMapData = this.regionsMapData;
                if (this.lsData) {
                  var regions_data = this.extractRegionData(indicator,this.selectedYear);
                  this.mapPlotData = regions_data;
                  this.options.title.text = indicator;
                    this.options.exporting.filename = indicator +" ("+ source +' - '+ this.selectedYear +")";
                  this.options.subtitle.text = source + ' - ' + this.selectedYear;
                  this.options.series[0].name = source;
                  this.plotMap(regions_data);
                }

                return "Nigeria Map";
            },
            extractRegionData(indicator,selectedYear) {
                let indicatorSource = indicator + ' -> ' + this.selectedSource;
                let regions = Object.keys(this.stateToShortCode);
                let lsData = this.appData.slice(1);
                let indexOfIndicatorSource = this.appData[0].indexOf(indicatorSource);
                let regionsData = {};
                regions.map((elem,index) => {
                    regionsData[elem] = {};
                    lsData.map((el,i) => {
                        if(el[0] === selectedYear && el[1] === elem){
                            if(el[indexOfIndicatorSource] !== ""){
                                regionsData[elem] = el[indexOfIndicatorSource];
                                this.chartHasNoData = false;
                            } else {
                                regionsData[elem] = 0;
                                this.chartHasNoData = true;
                            }
                            
                        }
                    });
                });
                return regionsData;

            },
            yearComputation(indicator,source){
                this.getYearOptionsWithData(indicator,source);
                if(this.optionYear.length > 0){
                    this.selectedYear = this.optionYear.reduce(function(a, b) { return Math.max(a, b); });
                } else {
                    this.selectedYear = 0;
                }
          }
        },
        computed: {

        },
        updated() {
            
        },
        mounted() {
            if (this.lsData) {
                if (this.selectedIndicator.length < 1) {
                    this.getCurrentSourceOptions(this.relativeIndicator);
                    let randomSource = Math.floor(Math.random() * this.optionSources.length);
                    if (this.optionSources.indexOf('MICS')== -1){
                        this.selectedSource = this.optionSources[0];
                    } else {
                        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
                    }

                    this.yearComputation(this.relativeIndicator,this.selectedSource);
                    if(this.selectedYear > 0){
                        this.computeMapData(this.relativeIndicator,this.selectedSource);
                    } else {
                        this.chartHasNoData = true;
                    }
                } else {
                    if (this.indicatorClicked.length > 1){
                        this.getCurrentSourceOptions(this.indicatorClicked);
                        let randomSource = Math.floor(Math.random() * this.optionSources.length);
                        this.selectedSource = this.sourceClicked;
                        this.yearComputation(this.indicatorClicked,this.selectedSource);
                        this.selectedYear = this.yearClicked;
                        if(this.selectedYear > 0){
                            this.computeMapData(this.indicatorClicked,this.selectedSource);
                        } else {
                            this.chartHasNoData = true;
                        }
                    } else {
                        this.getCurrentSourceOptions(this.selectedIndicator);
                        let randomSource = Math.floor(Math.random() * this.optionSources.length);
                        this.selectedSource = this.sourceClicked;
                        this.yearComputation(this.selectedIndicator,this.selectedSource);
                        this.selectedYear = this.yearClicked;
                        if(this.selectedYear > 0){
                            this.computeMapData(this.selectedIndicator,this.selectedSource);
                        } else {
                            this.chartHasNoData = true;
                        }
                    }
                }
                // this.$store.dispatch('storeIndicatorSelected',this.relativeIndicator);
            }
            // this.plotMap();
            // Create the chart
            // console.log(this.options)
        },
        watch: {
            selectedIndicator(val){
                this.getCurrentSourceOptions(this.relativeIndicator);
                let randomSource = Math.floor(Math.random() * this.optionSources.length);
                this.selectedSource = this.sourceClicked;
               
                if(this.selectedYear > 0){
                    this.computeMapData(val,this.selectedSource);
                } else {
                    this.chartHasNoData = true;
                }
            },
            sourceClicked(val){
                this.selectedSource = val;
                if(this.selectedIndicator !== ''){
                    this.yearComputation(this.selectedIndicator,val);
                    if(this.selectedYear > 0){
                        this.computeMapData(this.selectedIndicator,val);
                    } else {
                        this.chartHasNoData = true;
                    }
                } else {
                    this.yearComputation(this.relativeIndicator,val);
                    if(this.selectedYear > 0){
                        this.computeMapData(this.relativeIndicator,val);
                    } else {
                        this.chartHasNoData = true;
                    }
                }
            },
            yearClicked(val){
                this.selectedYear = val;
                if(this.selectedIndicator !== ''){
                    if(val > 0){
                        this.computeMapData(this.selectedIndicator,this.selectedSource);
                    } else {
                        this.chartHasNoData = true;
                    }
                } else {
                    if(val > 0){
                        this.computeMapData(this.relativeIndicator,this.selectedSource);
                    } else {
                        this.chartHasNoData = true;
                    }
                }
            },
            indicatorClicked(val){
                this.getCurrentSourceOptions(val);
                let randomSource = Math.floor(Math.random() * this.optionSources.length);
                this.selectedSource = this.sourceClicked;
              
                if(this.selectedYear > 0){
                    this.computeMapData(val,this.selectedSource);
                } else {
                    this.chartHasNoData = true;
                }
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// regions.vue?bbe6e2ae